module.exports = "/assets/data/4122f169177a22e88436b3d19727814e-SY8.data.json";